"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function NuestraHistoriaYMisiN() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: storyRef,
    isVisible: storyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraphs = [{
    id: 1,
    text: "undada bajo los principios de disciplina y precisión táctica, la Agencia Nacional de Seguridad Privada Poseidón nació de la necesidad de elevar los estándares de protección en el territorio nacional. Lo que comenzó como una unidad especializada de consultoría estratégica ha evolucionado hasta convertirse en un referente de seguridad integral, donde cada protocolo es diseñado con el rigor de la inteligencia moderna y la firmeza de un compromiso inquebrantable.",
    dropcap: true
  }, {
    id: 2,
    text: "Cada estrategia de seguridad que implementamos es el resultado de un análisis exhaustivo de riesgos y vulnerabilidades. Seleccionamos a nuestro personal mediante procesos de evaluación psicométrica y técnica de alto nivel, asegurando que solo los perfiles más aptos porten el distintivo de Poseidón. Nada en nuestra operación queda al azar; cada movimiento está coordinado por nuestro centro de monitoreo avanzado.",
    dropcap: false
  }, {
    id: 3,
    text: "Nuestra misión trasciende la vigilancia convencional; buscamos crear entornos de absoluta confianza donde la tecnología y el factor humano convergen en una defensa impenetrable. La prevención, creemos, es la única medida que garantiza la continuidad de su tranquilidad.",
    dropcap: false,
    isPullQuote: true
  }, {
    id: 4,
    text: "Grupo Poseidón no se define por el volumen de sus contratos, sino por la solidez de su protección. Somos el escudo invisible que resguarda sus activos más valiosos, operando con la discreción y el profesionalismo que su empresa exige. Le invitamos a conocer una nueva era en seguridad privada, donde su paz mental es nuestro objetivo supremo.",
    dropcap: false
  }];
  return <section data-section-id="3004" id="nuestra-historia-y-misión" className="bg-background text-foreground">
      {}
      <div ref={heroRef} className={`relative w-full h-[60vh] min-h-[480px] overflow-hidden transition-opacity duration-1000 ${heroVisible ? "opacity-100" : "opacity-0"}`}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_hq_exterior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_hq_exterior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_hq_exterior.png-wvc-sizes" alt="Sede central de Grupo Poseidón" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to bottom, hsla(220, 15%, 6%, 0.4) 0%, hsla(220, 15%, 6%, 0.2) 40%, hsla(220, 15%, 6%, 0.9) 100%)"
      }} />

        {}
        <div className="absolute inset-x-0 bottom-0 pb-12 sm:pb-16 md:pb-20 px-6 sm:px-10">
          <div className="max-w-6xl mx-auto text-center">
            <p className={`font-mono text-[10px] sm:text-xs tracking-[0.35em] uppercase text-primary mb-6 transition-all duration-1000 delay-200 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
              Nuestra Historia <span className="mx-2 opacity-60">—</span> Grupo Poseidón
            </p>
            <h1 className={`font-default font-bold text-foreground leading-[0.95] tracking-tighter text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[96px] transition-all duration-1000 delay-300 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Protección con
              <br />
              <span className="italic font-medium text-primary">Precisión</span>
            </h1>
          </div>
        </div>
      </div>

      {}
      <div ref={storyRef} className="px-6 sm:px-10 lg:px-16 pt-24 md:pt-36 lg:pt-48 pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
            {}
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-24 space-y-8">
                <div className={`transition-all duration-700 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                  <p className="font-default text-primary text-3xl md:text-4xl font-semibold mb-3">
                    01 <span className="opacity-60">—</span>
                  </p>
                  <p className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">
                    El Origen
                  </p>
                </div>

                <Separator className="bg-border/60 max-w-[120px]" />

                <div className={`transition-all duration-700 delay-150 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                  <div className="relative w-full max-w-[260px] aspect-[3/4] overflow-hidden mb-6 shadow-xl">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/director_seguridad_poseidon.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/director_seguridad_poseidon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/director_seguridad_poseidon.png-wvc-sizes" alt="Director General de Grupo Poseidón" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
                    filter: "grayscale(0.5) contrast(1.1) brightness(0.9)"
                  }} />
                    <div className="absolute inset-0 pointer-events-none" style={{
                    background: "linear-gradient(180deg, hsla(222, 47%, 11%, 0.1) 0%, hsla(220, 15%, 6%, 0.3) 100%)"
                  }} />
                  </div>
                  <p className="font-default font-semibold text-xl md:text-2xl text-foreground leading-snug">
                    Dirección General
                  </p>
                  <p className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mt-2">
                    Estrategia &middot; Operaciones Tácticas
                  </p>
                </div>
              </div>
            </aside>

            {}
            <div className="lg:col-span-8">
              <article className="space-y-10">
                {paragraphs.map((para, i) => {
                if (para.isPullQuote) {
                  return <div key={para.id} data-index={i} className={`relative py-6 md:py-10 px-6 md:px-10 transition-all duration-700 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                        <span aria-hidden="true" className="absolute left-0 top-4 bottom-4 w-px bg-primary" />
                        <span aria-hidden="true" className="absolute right-0 top-4 bottom-4 w-px bg-primary" />
                        <p className="font-default italic text-primary text-2xl md:text-3xl lg:text-[32px] leading-[1.5] text-center font-medium">
                          {para.text}
                        </p>
                      </div>;
                }
                if (para.dropcap) {
                  return <p key={para.id} data-index={i} className={`font-default text-foreground/90 text-lg leading-[1.8] transition-all duration-700 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                        <span className="float-left font-default text-primary text-[120px] leading-[0.85] mr-3 mt-1 font-bold">
                          F
                        </span>
                        {para.text}
                      </p>;
                }
                return <div key={para.id} data-index={i}>
                      <p className={`font-default text-foreground/90 text-lg leading-[1.8] transition-all duration-700 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                        {para.text}
                      </p>

                      {}
                      {i < paragraphs.length - 1 && <div aria-hidden="true" className="flex items-center justify-center gap-4 my-12">
                          <span className="h-px w-12 bg-border" />
                          <svg width="40" height="20" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary">
                            <path d="M20 2C16 6 12 10 4 10C12 10 16 14 20 18C24 14 28 10 36 10C28 10 24 6 20 2Z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                            <rect x="19" y="9" width="2" height="2" fill="currentColor" />
                          </svg>
                          <span className="h-px w-12 bg-border" />
                        </div>}
                    </div>;
              })}

                {}
                <div className={`pt-8 transition-all duration-700 delay-200 ${storyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                  <p className="text-primary text-4xl md:text-5xl leading-none font-semibold" style={{
                  fontFamily: 'var(--font-serif)',
                  display: "inline-block"
                }}>
                    Grupo Poseidón
                  </p>
                  <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mt-4">
                    Seguridad Privada &middot; México
                  </p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>;
}